export default __webpack_public_path__ + "static/media/t2p_logo_white_letters.3f05643d.svg";